<template lang="html">
    <div class="dynamic" ref="dynamic">
      <div class="header">
        <span># {{$route.params.title}}</span>
        <img @click="goBack" src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/close-white1.svg"/>
      </div>
      <List v-model="loading" :finished="finished" @onload="getDynamic">
          <DynamicItem @click="goDetails()" @deleteMessage="deleteMessage" @updateItem="(reload) => updateItem(item, reload)" v-for="item of dynamic" :key="item.id" v-bind="item" />
      </List>
    </div>
</template>
<script>
import { isAndroid } from '../../../utils/utils'
import DynamicItem from '../../../components/DynamicItem'
import { get } from '../../../utils/request'
import { set, remove, get as getUser } from '../../../utils/token'
import { createNamespacedHelpers } from 'vuex'
import List from '../../../components/list'
import { Toast } from 'vant'
const { mapActions } = createNamespacedHelpers('tabbar')
const { mapActions: messageMapActions } = createNamespacedHelpers('message')
export default {
  components: {
    DynamicItem,
    List
  },
  activated () {
    // 埋点 使用了缓存所以需要在这个钩子里埋点
    this.upUvdata()
    this.page = 1
    this.count = 0
    this.dynamic.length = 0
    this.finished = false
    this.getDynamic()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.updateTabIndex('dynamic')
    })
  },
  beforeRouteUpdate (to, from, next) {
    next()
    this.dynamic.length = 0
    this.getDynamic()
  },
  data () {
    return {
      isAndroid: isAndroid(),
      safeHeight: 0,
      dynamic: [],
      loading: false,
      finished: false,
      downRefresh: false,
      downLabel: '',
      touchStart: 0,
      page: 1,
      size: 10,
      count: 0
    }
  },
  methods: {
    // 用于埋点分析URL地址
    upUvdata () {
      const url = decodeURIComponent(window.location.pathname)
      const urlSplit = url.split('exerland')
      const urlSplit1 = url.split('/')
      this.$API.upUvData({
        user: getUser('user').id,
        path: `/exerland${urlSplit[urlSplit.length - 1]}`,
        location: `话题列表-${urlSplit1[urlSplit1.length - 1]}`,
        tracking_type: 3
      })
    },
    goBack () {
      this.$router.back()
    },
    ...mapActions({
      updateTabIndex: 'updateTabIndex'
    }),
    ...messageMapActions({
      updateStarCircleCount: 'updateStarCircleCount'
    }),
    updateItem (item, reload) {
      Object.assign(item, reload)
    },
    async onRefresh () {
      this.downRefresh = true
      this.getDynamic()
    },
    deleteMessage (id) {
      let index = 0
      this.dynamic.forEach((item, _index) => {
        if (Object.is(id, item.id)) {
          index = _index
        }
      })
      this.dynamic.splice(index, 1)
    },
    resetPagination () {
      this.downLabel = ''
      this.touchStart = 0
      this.distance = 0
    },
    scrollLocation () {
      this.$nextTick(() => {
        const scrollTop = getUser('scrollDynamic')
        if (scrollTop) {
          this.$refs.dynamic.scrollTop = scrollTop
          remove('scrollDynamic')
        }
      })
    },
    goDetails () {
      set('scrollDynamic', this.$refs.dynamic.scrollTop)
    },
    getDynamic () {
      const { page, size } = this
      const { id } = this.$route.params
      const promise = get({
        url: `/circle/circle?page=${page}&size=${size}&user=${
          getUser('user').id
        }&tagId=${id}`
      })
      promise.then(res => {
        const {
          data: {
            code,
            detail: { count, data }
          }
        } = res
        if (Object.is(code, 200)) {
          this.updateStarCircleCount(0)
          this.count = count
          // 下拉刷新时
          if (this.downRefresh) {
            this.dynamic = data
            this.downRefresh = false
            Toast.success('刷新成功')
          } else {
            this.dynamic = [...this.dynamic, ...data]
          }
          this.loading = false
          const { dynamic, page } = this
          if (count > dynamic.length) {
            this.loading = true
            this.page = page + 1
          } else {
            this.finished = true
          }
          this.loading = false
          this.scrollLocation()
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}
@keyframes bounce-in {
  from {
    height: 0;
  }
  to {
    height: 50px;
  }
}
.dynamic {
  background: #fff;
  box-sizing: border-box;
  z-index: 1;
  height: calc(100% - 50px);
  overflow-y: hidden;
  .header {
    padding: 12px 16px;
    width: 100%;
    height: 49px;
    box-sizing: border-box;
    background: #18CC9F;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: space-between;
    span {
      font-size: 17px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 24px;
    }
    img {
      width: 16px;
      height: 16px;
    }
  }
  .downLoading {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 50px;
    text-align: center;
    background: #fff;
  }
  h3 {
    font-size: 17px;
    font-family: SFProText-Semibold, SFProText;
    font-weight: 600;
    color: rgba(0, 0, 0, 1);
    line-height: 22px;
    text-align: center;
    padding: 13px 4.27vw;
  }
  .content {
    margin-bottom: 1px;
  }
  .loading {
    background: #fff;
    display: block;
    width: 100vw;
    height: 50px;
    line-height: 50px;
    text-align: center;
  }
}
/deep/ .van-pull-refresh {
  height: 100%;
  overflow-y: scroll;
}
</style>
